<template>
    <div class="flex flex-col items-center justify-between shadow-lg">
        <div class="w-full">
            <brand-logo class="flex items-center justify-center h-18 border-gray-200 border-b | 2xl:h-22" />

            <nav class="flex flex-col justify-center w-full">
                <main-nav-item
                    :badge="conversationsWithUnreadMessagesCount"
                    icon="regular/messages-bubble-double"
                    :title="$t('global.mainNav.chat')"
                    :to="{ name: 'chat' }"
                />
                <main-nav-item
                    icon="regular/calendar-3"
                    :title="$t('global.mainNav.appointments')"
                    :to="{ name: 'appointments' }"
                    v-if="hasAccessToAppointment"
                />
                <main-nav-item
                    icon="regular/megaphone"
                    :title="$t('global.mainNav.campaigns')"
                    :to="{ name: 'campaigns' }"
                    v-if="hasAccessToCampaign"
                />
                <main-nav-item
                    icon="regular/accounting-document"
                    :title="$t('global.mainNav.payments')"
                    :to="{ name: 'payments' }"
                    v-if="hasAccessToPayment"
                />
                <main-nav-item
                    icon="regular/multiple-neutral-2"
                    :title="$t('global.mainNav.contacts')"
                    :to="{ name: 'contacts' }"
                />
                <main-nav-item
                    icon="regular/robot-2"
                    :title="$t('global.mainNav.automations')"
                    :to="{ name: 'automations' }"
                    v-if="hasAccessToAppointment"
                />
                <main-nav-item
                    icon="regular/download-bottom"
                    :title="$t('global.mainNav.imports')"
                    :to="{ name: 'imports' }"
                    v-if="hasAccessToAppointment || hasAccessToCampaign"
                />
            </nav>
        </div>

        <nav-user-dropdown v-if="!$configs.inIframe" />
    </div>
</template>

<script>
    import { mapGetters, mapState } from 'vuex';
    import BrandLogo from '@/components/BrandLogo.vue';
    import MainNavItem from '@/components/Navs/MainNavItem.vue';
    import NavUserDropdown from '@/components/Navs/NavUserDropdown.vue';

    export default {
        components: {
            BrandLogo,
            MainNavItem,
            NavUserDropdown,
        },

        computed: {
            ...mapState([
                'authUser',
            ]),

            ...mapGetters([
                'hasAccessToAppointment',
                'hasAccessToCampaign',
                'hasAccessToPayment',
            ]),

            ...mapGetters('chat', [
                'conversationsWithUnreadMessagesCount',
            ]),
        },
    };
</script>

<style>
    .nav-item:before {
        @apply absolute inset-0 opacity-0 rounded-r w-full h-full transition duration-300 ease-in-out;
        z-index: -1;
        content: '';
        background: linear-gradient(45deg, var(--blue-gradient-dark), var(--blue-gradient-light));
    }

    .nav-item.active:before {
        @apply opacity-100;
    }
</style>
